// Comprehensive countries + cities database used for service localisation.
//
// COUNTRIES: every sovereign country (and main territories) with its flag emoji
// and international dial code. Names are in French (proper nouns, shown next to
// the flag so they read well in any UI language).
//
// CITIES_BY_COUNTRY: main cities per country. Rich lists for the countries most
// relevant to the app; capital + major cities for the rest. The city field in
// the UI also accepts free text (via a datalist), so any city can be entered
// even if it is not pre-listed — the database is therefore effectively complete.

export const COUNTRIES = [
  { code: 'FR', name: 'France', flag: '🇫🇷', dial: '+33' },
  { code: 'BE', name: 'Belgique', flag: '🇧🇪', dial: '+32' },
  { code: 'CH', name: 'Suisse', flag: '🇨🇭', dial: '+41' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺', dial: '+352' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', dial: '+1' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨', dial: '+377' },
  { code: 'DE', name: 'Allemagne', flag: '🇩🇪', dial: '+49' },
  { code: 'NL', name: 'Pays-Bas', flag: '🇳🇱', dial: '+31' },
  { code: 'GB', name: 'Royaume-Uni', flag: '🇬🇧', dial: '+44' },
  { code: 'IE', name: 'Irlande', flag: '🇮🇪', dial: '+353' },
  { code: 'ES', name: 'Espagne', flag: '🇪🇸', dial: '+34' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', dial: '+351' },
  { code: 'IT', name: 'Italie', flag: '🇮🇹', dial: '+39' },
  { code: 'AT', name: 'Autriche', flag: '🇦🇹', dial: '+43' },
  { code: 'DK', name: 'Danemark', flag: '🇩🇰', dial: '+45' },
  { code: 'SE', name: 'Suède', flag: '🇸🇪', dial: '+46' },
  { code: 'NO', name: 'Norvège', flag: '🇳🇴', dial: '+47' },
  { code: 'FI', name: 'Finlande', flag: '🇫🇮', dial: '+358' },
  { code: 'IS', name: 'Islande', flag: '🇮🇸', dial: '+354' },
  { code: 'PL', name: 'Pologne', flag: '🇵🇱', dial: '+48' },
  { code: 'CZ', name: 'Tchéquie', flag: '🇨🇿', dial: '+420' },
  { code: 'SK', name: 'Slovaquie', flag: '🇸🇰', dial: '+421' },
  { code: 'HU', name: 'Hongrie', flag: '🇭🇺', dial: '+36' },
  { code: 'RO', name: 'Roumanie', flag: '🇷🇴', dial: '+40' },
  { code: 'BG', name: 'Bulgarie', flag: '🇧🇬', dial: '+359' },
  { code: 'GR', name: 'Grèce', flag: '🇬🇷', dial: '+30' },
  { code: 'HR', name: 'Croatie', flag: '🇭🇷', dial: '+385' },
  { code: 'SI', name: 'Slovénie', flag: '🇸🇮', dial: '+386' },
  { code: 'RS', name: 'Serbie', flag: '🇷🇸', dial: '+381' },
  { code: 'BA', name: 'Bosnie-Herzégovine', flag: '🇧🇦', dial: '+387' },
  { code: 'ME', name: 'Monténégro', flag: '🇲🇪', dial: '+382' },
  { code: 'MK', name: 'Macédoine du Nord', flag: '🇲🇰', dial: '+389' },
  { code: 'AL', name: 'Albanie', flag: '🇦🇱', dial: '+355' },
  { code: 'XK', name: 'Kosovo', flag: '🇽🇰', dial: '+383' },
  { code: 'EE', name: 'Estonie', flag: '🇪🇪', dial: '+372' },
  { code: 'LV', name: 'Lettonie', flag: '🇱🇻', dial: '+371' },
  { code: 'LT', name: 'Lituanie', flag: '🇱🇹', dial: '+370' },
  { code: 'BY', name: 'Biélorussie', flag: '🇧🇾', dial: '+375' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', dial: '+380' },
  { code: 'MD', name: 'Moldavie', flag: '🇲🇩', dial: '+373' },
  { code: 'RU', name: 'Russie', flag: '🇷🇺', dial: '+7' },
  { code: 'MT', name: 'Malte', flag: '🇲🇹', dial: '+356' },
  { code: 'CY', name: 'Chypre', flag: '🇨🇾', dial: '+357' },
  { code: 'AD', name: 'Andorre', flag: '🇦🇩', dial: '+376' },
  { code: 'SM', name: 'Saint-Marin', flag: '🇸🇲', dial: '+378' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', dial: '+423' },
  { code: 'US', name: 'États-Unis', flag: '🇺🇸', dial: '+1' },
  { code: 'MX', name: 'Mexique', flag: '🇲🇽', dial: '+52' },
  { code: 'BR', name: 'Brésil', flag: '🇧🇷', dial: '+55' },
  { code: 'AR', name: 'Argentine', flag: '🇦🇷', dial: '+54' },
  { code: 'CL', name: 'Chili', flag: '🇨🇱', dial: '+56' },
  { code: 'CO', name: 'Colombie', flag: '🇨🇴', dial: '+57' },
  { code: 'PE', name: 'Pérou', flag: '🇵🇪', dial: '+51' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', dial: '+58' },
  { code: 'EC', name: 'Équateur', flag: '🇪🇨', dial: '+593' },
  { code: 'BO', name: 'Bolivie', flag: '🇧🇴', dial: '+591' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾', dial: '+595' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', dial: '+598' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', dial: '+502' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺', dial: '+53' },
  { code: 'DO', name: 'République dominicaine', flag: '🇩🇴', dial: '+1' },
  { code: 'HT', name: 'Haïti', flag: '🇭🇹', dial: '+509' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', dial: '+506' },
  { code: 'PA', name: 'Panama', flag: '🇵🇦', dial: '+507' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳', dial: '+504' },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮', dial: '+505' },
  { code: 'SV', name: 'Salvador', flag: '🇸🇻', dial: '+503' },
  { code: 'JM', name: 'Jamaïque', flag: '🇯🇲', dial: '+1' },
  { code: 'TT', name: 'Trinité-et-Tobago', flag: '🇹🇹', dial: '+1' },
  { code: 'MA', name: 'Maroc', flag: '🇲🇦', dial: '+212' },
  { code: 'DZ', name: 'Algérie', flag: '🇩🇿', dial: '+213' },
  { code: 'TN', name: 'Tunisie', flag: '🇹🇳', dial: '+216' },
  { code: 'LY', name: 'Libye', flag: '🇱🇾', dial: '+218' },
  { code: 'EG', name: 'Égypte', flag: '🇪🇬', dial: '+20' },
  { code: 'SN', name: 'Sénégal', flag: '🇸🇳', dial: '+221' },
  { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮', dial: '+225' },
  { code: 'CM', name: 'Cameroun', flag: '🇨🇲', dial: '+237' },
  { code: 'CD', name: 'RD Congo', flag: '🇨🇩', dial: '+243' },
  { code: 'CG', name: 'Congo', flag: '🇨🇬', dial: '+242' },
  { code: 'GA', name: 'Gabon', flag: '🇬🇦', dial: '+241' },
  { code: 'BJ', name: 'Bénin', flag: '🇧🇯', dial: '+229' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬', dial: '+228' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱', dial: '+223' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', dial: '+226' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪', dial: '+227' },
  { code: 'GN', name: 'Guinée', flag: '🇬🇳', dial: '+224' },
  { code: 'GW', name: 'Guinée-Bissau', flag: '🇬🇼', dial: '+245' },
  { code: 'GQ', name: 'Guinée équatoriale', flag: '🇬🇶', dial: '+240' },
  { code: 'MR', name: 'Mauritanie', flag: '🇲🇷', dial: '+222' },
  { code: 'TD', name: 'Tchad', flag: '🇹🇩', dial: '+235' },
  { code: 'CF', name: 'Centrafrique', flag: '🇨🇫', dial: '+236' },
  { code: 'RW', name: 'Rwanda', flag: '🇷🇼', dial: '+250' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮', dial: '+257' },
  { code: 'DJ', name: 'Djibouti', flag: '🇩🇯', dial: '+253' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬', dial: '+261' },
  { code: 'MU', name: 'Maurice', flag: '🇲🇺', dial: '+230' },
  { code: 'SC', name: 'Seychelles', flag: '🇸🇨', dial: '+248' },
  { code: 'KM', name: 'Comores', flag: '🇰🇲', dial: '+269' },
  { code: 'ST', name: 'Sao Tomé-et-Principe', flag: '🇸🇹', dial: '+239' },
  { code: 'CV', name: 'Cap-Vert', flag: '🇨🇻', dial: '+238' },
  { code: 'NG', name: 'Nigéria', flag: '🇳🇬', dial: '+234' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', dial: '+233' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', dial: '+254' },
  { code: 'TZ', name: 'Tanzanie', flag: '🇹🇿', dial: '+255' },
  { code: 'UG', name: 'Ouganda', flag: '🇺🇬', dial: '+256' },
  { code: 'ET', name: 'Éthiopie', flag: '🇪🇹', dial: '+251' },
  { code: 'ZA', name: 'Afrique du Sud', flag: '🇿🇦', dial: '+27' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴', dial: '+244' },
  { code: 'MZ', name: 'Mozambique', flag: '🇲🇿', dial: '+258' },
  { code: 'ZM', name: 'Zambie', flag: '🇿🇲', dial: '+260' },
  { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼', dial: '+263' },
  { code: 'BW', name: 'Botswana', flag: '🇧🇼', dial: '+267' },
  { code: 'NA', name: 'Namibie', flag: '🇳🇦', dial: '+264' },
  { code: 'SD', name: 'Soudan', flag: '🇸🇩', dial: '+249' },
  { code: 'GM', name: 'Gambie', flag: '🇬🇲', dial: '+220' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱', dial: '+232' },
  { code: 'LR', name: 'Liberia', flag: '🇱🇷', dial: '+231' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼', dial: '+265' },
  { code: 'SA', name: 'Arabie saoudite', flag: '🇸🇦', dial: '+966' },
  { code: 'AE', name: 'Émirats arabes unis', flag: '🇦🇪', dial: '+971' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦', dial: '+974' },
  { code: 'KW', name: 'Koweït', flag: '🇰🇼', dial: '+965' },
  { code: 'BH', name: 'Bahreïn', flag: '🇧🇭', dial: '+973' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲', dial: '+968' },
  { code: 'JO', name: 'Jordanie', flag: '🇯🇴', dial: '+962' },
  { code: 'LB', name: 'Liban', flag: '🇱🇧', dial: '+961' },
  { code: 'IL', name: 'Israël', flag: '🇮🇱', dial: '+972' },
  { code: 'PS', name: 'Palestine', flag: '🇵🇸', dial: '+970' },
  { code: 'TR', name: 'Turquie', flag: '🇹🇷', dial: '+90' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷', dial: '+98' },
  { code: 'IQ', name: 'Irak', flag: '🇮🇶', dial: '+964' },
  { code: 'SY', name: 'Syrie', flag: '🇸🇾', dial: '+963' },
  { code: 'YE', name: 'Yémen', flag: '🇾🇪', dial: '+967' },
  { code: 'CN', name: 'Chine', flag: '🇨🇳', dial: '+86' },
  { code: 'JP', name: 'Japon', flag: '🇯🇵', dial: '+81' },
  { code: 'KR', name: 'Corée du Sud', flag: '🇰🇷', dial: '+82' },
  { code: 'IN', name: 'Inde', flag: '🇮🇳', dial: '+91' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', dial: '+92' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', dial: '+880' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', dial: '+94' },
  { code: 'NP', name: 'Népal', flag: '🇳🇵', dial: '+977' },
  { code: 'TH', name: 'Thaïlande', flag: '🇹🇭', dial: '+66' },
  { code: 'VN', name: 'Viêt Nam', flag: '🇻🇳', dial: '+84' },
  { code: 'ID', name: 'Indonésie', flag: '🇮🇩', dial: '+62' },
  { code: 'MY', name: 'Malaisie', flag: '🇲🇾', dial: '+60' },
  { code: 'SG', name: 'Singapour', flag: '🇸🇬', dial: '+65' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', dial: '+63' },
  { code: 'KH', name: 'Cambodge', flag: '🇰🇭', dial: '+855' },
  { code: 'LA', name: 'Laos', flag: '🇱🇦', dial: '+856' },
  { code: 'MM', name: 'Myanmar', flag: '🇲🇲', dial: '+95' },
  { code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿', dial: '+7' },
  { code: 'UZ', name: 'Ouzbékistan', flag: '🇺🇿', dial: '+998' },
  { code: 'AZ', name: 'Azerbaïdjan', flag: '🇦🇿', dial: '+994' },
  { code: 'GE', name: 'Géorgie', flag: '🇬🇪', dial: '+995' },
  { code: 'AM', name: 'Arménie', flag: '🇦🇲', dial: '+374' },
  { code: 'AU', name: 'Australie', flag: '🇦🇺', dial: '+61' },
  { code: 'NZ', name: 'Nouvelle-Zélande', flag: '🇳🇿', dial: '+64' },
  { code: 'FJ', name: 'Fidji', flag: '🇫🇯', dial: '+679' },
  { code: 'PF', name: 'Polynésie française', flag: '🇵🇫', dial: '+689' },
  { code: 'NC', name: 'Nouvelle-Calédonie', flag: '🇳🇨', dial: '+687' },
  { code: 'RE', name: 'La Réunion', flag: '🇷🇪', dial: '+262' },
  { code: 'GP', name: 'Guadeloupe', flag: '🇬🇵', dial: '+590' },
  { code: 'MQ', name: 'Martinique', flag: '🇲🇶', dial: '+596' },
  { code: 'GF', name: 'Guyane', flag: '🇬🇫', dial: '+594' },
  { code: 'YT', name: 'Mayotte', flag: '🇾🇹', dial: '+262' },
  // --- Pays et territoires ajoutés pour compléter la liste (ordre indifférent : le tri est fait à l'affichage) ---
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫', dial: '+93' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸', dial: '+1' },
  { code: 'BB', name: 'Barbade', flag: '🇧🇧', dial: '+1' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿', dial: '+501' },
  { code: 'BT', name: 'Bhoutan', flag: '🇧🇹', dial: '+975' },
  { code: 'BN', name: 'Brunei', flag: '🇧🇳', dial: '+673' },
  { code: 'DM', name: 'Dominique', flag: '🇩🇲', dial: '+1' },
  { code: 'AG', name: 'Antigua-et-Barbuda', flag: '🇦🇬', dial: '+1' },
  { code: 'ER', name: 'Érythrée', flag: '🇪🇷', dial: '+291' },
  { code: 'SZ', name: 'Eswatini', flag: '🇸🇿', dial: '+268' },
  { code: 'GD', name: 'Grenade', flag: '🇬🇩', dial: '+1' },
  { code: 'GY', name: 'Guyana', flag: '🇬🇾', dial: '+592' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮', dial: '+686' },
  { code: 'KG', name: 'Kirghizistan', flag: '🇰🇬', dial: '+996' },
  { code: 'LS', name: 'Lesotho', flag: '🇱🇸', dial: '+266' },
  { code: 'MV', name: 'Maldives', flag: '🇲🇻', dial: '+960' },
  { code: 'MH', name: 'Îles Marshall', flag: '🇲🇭', dial: '+692' },
  { code: 'FM', name: 'Micronésie', flag: '🇫🇲', dial: '+691' },
  { code: 'MN', name: 'Mongolie', flag: '🇲🇳', dial: '+976' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷', dial: '+674' },
  { code: 'PW', name: 'Palaos', flag: '🇵🇼', dial: '+680' },
  { code: 'PG', name: 'Papouasie-Nouvelle-Guinée', flag: '🇵🇬', dial: '+675' },
  { code: 'KN', name: 'Saint-Kitts-et-Nevis', flag: '🇰🇳', dial: '+1' },
  { code: 'LC', name: 'Sainte-Lucie', flag: '🇱🇨', dial: '+1' },
  { code: 'VC', name: 'Saint-Vincent-et-les-Grenadines', flag: '🇻🇨', dial: '+1' },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸', dial: '+685' },
  { code: 'SB', name: 'Îles Salomon', flag: '🇸🇧', dial: '+677' },
  { code: 'SO', name: 'Somalie', flag: '🇸🇴', dial: '+252' },
  { code: 'SS', name: 'Soudan du Sud', flag: '🇸🇸', dial: '+211' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷', dial: '+597' },
  { code: 'TJ', name: 'Tadjikistan', flag: '🇹🇯', dial: '+992' },
  { code: 'TL', name: 'Timor oriental', flag: '🇹🇱', dial: '+670' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴', dial: '+676' },
  { code: 'TM', name: 'Turkménistan', flag: '🇹🇲', dial: '+993' },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', dial: '+688' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', dial: '+678' },
  { code: 'VA', name: 'Vatican', flag: '🇻🇦', dial: '+379' },
  { code: 'TW', name: 'Taïwan', flag: '🇹🇼', dial: '+886' },
  { code: 'MF', name: 'Saint-Martin', flag: '🇲🇫', dial: '+590' },
  { code: 'BL', name: 'Saint-Barthélemy', flag: '🇧🇱', dial: '+590' },
  { code: 'PM', name: 'Saint-Pierre-et-Miquelon', flag: '🇵🇲', dial: '+508' },
  { code: 'WF', name: 'Wallis-et-Futuna', flag: '🇼🇫', dial: '+681' },
  { code: 'GI', name: 'Gibraltar', flag: '🇬🇮', dial: '+350' },
  { code: 'GL', name: 'Groenland', flag: '🇬🇱', dial: '+299' },
  { code: 'FO', name: 'Îles Féroé', flag: '🇫🇴', dial: '+298' },
  { code: 'JE', name: 'Jersey', flag: '🇯🇪', dial: '+44' },
  { code: 'GG', name: 'Guernesey', flag: '🇬🇬', dial: '+44' },
  { code: 'IM', name: 'Île de Man', flag: '🇮🇲', dial: '+44' },
  { code: 'HK', name: 'Hong Kong', flag: '🇭🇰', dial: '+852' },
  { code: 'MO', name: 'Macao', flag: '🇲🇴', dial: '+853' },
  { code: 'PR', name: 'Porto Rico', flag: '🇵🇷', dial: '+1' },
  { code: 'AW', name: 'Aruba', flag: '🇦🇼', dial: '+297' },
  { code: 'CW', name: 'Curaçao', flag: '🇨🇼', dial: '+599' },
]

export const CITIES_BY_COUNTRY = {
  FR: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes', 'Montpellier', 'Strasbourg', 'Bordeaux', 'Lille', 'Rennes', 'Reims', 'Le Havre', 'Saint-Étienne', 'Toulon', 'Grenoble', 'Dijon', 'Angers', 'Nîmes', 'Villeurbanne', 'Clermont-Ferrand', 'Le Mans', 'Aix-en-Provence', 'Brest', 'Tours', 'Amiens', 'Limoges', 'Annecy', 'Perpignan', 'Metz', 'Besançon', 'Orléans', 'Rouen', 'Mulhouse', 'Caen', 'Nancy', 'Avignon', 'Poitiers', 'Versailles', 'La Rochelle', 'Pau', 'Cannes', 'Antibes', 'Bayonne', 'Biarritz', 'Ajaccio', 'Bastia'],
  BE: ['Bruxelles', 'Anvers', 'Gand', 'Charleroi', 'Liège', 'Bruges', 'Namur', 'Louvain', 'Mons', 'Alost', 'Malines', 'La Louvière', 'Courtrai', 'Hasselt', 'Ostende', 'Tournai', 'Genk', 'Seraing', 'Roulers', 'Verviers', 'Wavre', 'Arlon'],
  CH: ['Zurich', 'Genève', 'Bâle', 'Lausanne', 'Berne', 'Winterthour', 'Lucerne', 'Saint-Gall', 'Lugano', 'Bienne', 'Thoune', 'Fribourg', 'Neuchâtel', 'Sion', 'Montreux', 'Vevey', 'Nyon', 'Yverdon-les-Bains'],
  LU: ['Luxembourg', 'Esch-sur-Alzette', 'Differdange', 'Dudelange', 'Ettelbruck', 'Diekirch', 'Wiltz', 'Echternach', 'Remich', 'Grevenmacher'],
  CA: ['Montréal', 'Toronto', 'Vancouver', 'Calgary', 'Ottawa', 'Edmonton', 'Québec', 'Winnipeg', 'Hamilton', 'Halifax', 'Victoria', 'Gatineau', 'Sherbrooke', 'Trois-Rivières', 'Laval', 'Longueuil', 'Saskatoon', 'Regina', 'London', 'Windsor'],
  MC: ['Monaco', 'Monte-Carlo', 'La Condamine', 'Fontvieille'],
  DE: ['Berlin', 'Hambourg', 'Munich', 'Cologne', 'Francfort', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen', 'Brême', 'Dresde', 'Hanovre', 'Nuremberg', 'Duisbourg', 'Bochum', 'Wuppertal', 'Bonn', 'Bielefeld', 'Mannheim', 'Karlsruhe', 'Münster', 'Augsbourg', 'Fribourg-en-Brisgau', 'Aix-la-Chapelle'],
  NL: ['Amsterdam', 'Rotterdam', 'La Haye', 'Utrecht', 'Eindhoven', 'Groningue', 'Tilbourg', 'Almere', 'Breda', 'Nimègue', 'Haarlem', 'Arnhem', 'Amersfoort', 'Bois-le-Duc', 'Maastricht', 'Delft', 'Leyde', 'Dordrecht'],
  GB: ['Londres', 'Birmingham', 'Manchester', 'Liverpool', 'Leeds', 'Sheffield', 'Bristol', 'Newcastle', 'Nottingham', 'Southampton', 'Leicester', 'Édimbourg', 'Glasgow', 'Cardiff', 'Belfast', 'Brighton', 'Oxford', 'Cambridge', 'York', 'Aberdeen'],
  IE: ['Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford', 'Drogheda', 'Dundalk', 'Kilkenny', 'Sligo'],
  ES: ['Madrid', 'Barcelone', 'Valence', 'Séville', 'Saragosse', 'Málaga', 'Murcie', 'Palma', 'Las Palmas', 'Bilbao', 'Alicante', 'Cordoue', 'Valladolid', 'Vigo', 'Gijón', 'Grenade', 'La Corogne', 'Saint-Sébastien', 'Santander', 'Pampelune', 'Tolède', 'Salamanque'],
  PT: ['Lisbonne', 'Porto', 'Vila Nova de Gaia', 'Amadora', 'Braga', 'Coimbra', 'Funchal', 'Faro', 'Aveiro', 'Setúbal', 'Guimarães', 'Évora', 'Cascais', 'Sintra'],
  IT: ['Rome', 'Milan', 'Naples', 'Turin', 'Palerme', 'Gênes', 'Bologne', 'Florence', 'Bari', 'Catane', 'Venise', 'Vérone', 'Messine', 'Padoue', 'Trieste', 'Brescia', 'Parme', 'Modène', 'Reggio de Calabre', 'Pise', 'Cagliari', 'Pérouse'],
  AT: ['Vienne', 'Graz', 'Linz', 'Salzbourg', 'Innsbruck', 'Klagenfurt', 'Villach', 'Wels', 'Sankt Pölten', 'Dornbirn'],
  DK: ['Copenhague', 'Aarhus', 'Odense', 'Aalborg', 'Esbjerg', 'Randers', 'Kolding', 'Horsens', 'Vejle', 'Roskilde'],
  SE: ['Stockholm', 'Göteborg', 'Malmö', 'Uppsala', 'Västerås', 'Örebro', 'Linköping', 'Helsingborg', 'Jönköping', 'Norrköping', 'Lund', 'Umeå'],
  NO: ['Oslo', 'Bergen', 'Trondheim', 'Stavanger', 'Drammen', 'Fredrikstad', 'Kristiansand', 'Tromsø', 'Sandnes', 'Ålesund'],
  FI: ['Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu', 'Turku', 'Jyväskylä', 'Lahti', 'Kuopio', 'Pori'],
  IS: ['Reykjavik', 'Kópavogur', 'Hafnarfjörður', 'Akureyri', 'Reykjanesbær'],
  PL: ['Varsovie', 'Cracovie', 'Łódź', 'Wrocław', 'Poznań', 'Gdańsk', 'Szczecin', 'Bydgoszcz', 'Lublin', 'Katowice', 'Białystok', 'Częstochowa'],
  CZ: ['Prague', 'Brno', 'Ostrava', 'Plzeň', 'Liberec', 'Olomouc', 'České Budějovice', 'Hradec Králové'],
  SK: ['Bratislava', 'Košice', 'Prešov', 'Žilina', 'Nitra', 'Banská Bystrica', 'Trnava', 'Trenčín'],
  HU: ['Budapest', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs', 'Győr', 'Nyíregyháza', 'Kecskemét'],
  RO: ['Bucarest', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Craiova', 'Brașov', 'Galați', 'Ploiești', 'Oradea'],
  BG: ['Sofia', 'Plovdiv', 'Varna', 'Bourgas', 'Roussé', 'Stara Zagora', 'Pleven', 'Sliven'],
  GR: ['Athènes', 'Thessalonique', 'Patras', 'Le Pirée', 'Larissa', 'Héraklion', 'Volos', 'Rhodes', 'Chania', 'Corfou'],
  HR: ['Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar', 'Dubrovnik', 'Pula', 'Sisak'],
  SI: ['Ljubljana', 'Maribor', 'Celje', 'Kranj', 'Koper', 'Novo Mesto'],
  RS: ['Belgrade', 'Novi Sad', 'Niš', 'Kragujevac', 'Subotica', 'Zrenjanin'],
  BA: ['Sarajevo', 'Banja Luka', 'Tuzla', 'Zenica', 'Mostar', 'Bihać'],
  ME: ['Podgorica', 'Nikšić', 'Herceg Novi', 'Budva', 'Bar', 'Kotor'],
  MK: ['Skopje', 'Bitola', 'Kumanovo', 'Prilep', 'Tetovo', 'Ohrid'],
  AL: ['Tirana', 'Durrës', 'Vlorë', 'Shkodër', 'Elbasan', 'Korçë'],
  XK: ['Pristina', 'Prizren', 'Ferizaj', 'Peja', 'Gjakova', 'Mitrovica'],
  EE: ['Tallinn', 'Tartu', 'Narva', 'Pärnu', 'Kohtla-Järve'],
  LV: ['Riga', 'Daugavpils', 'Liepāja', 'Jelgava', 'Jūrmala'],
  LT: ['Vilnius', 'Kaunas', 'Klaipėda', 'Šiauliai', 'Panevėžys'],
  BY: ['Minsk', 'Gomel', 'Moguilev', 'Vitebsk', 'Hrodna', 'Brest'],
  UA: ['Kiev', 'Kharkiv', 'Odessa', 'Dnipro', 'Donetsk', 'Zaporijjia', 'Lviv', 'Kryvyï Rih', 'Marioupol'],
  MD: ['Chișinău', 'Tiraspol', 'Bălți', 'Bender', 'Rîbnița'],
  RU: ['Moscou', 'Saint-Pétersbourg', 'Novossibirsk', 'Iekaterinbourg', 'Kazan', 'Nijni Novgorod', 'Tcheliabinsk', 'Samara', 'Omsk', 'Rostov-sur-le-Don', 'Oufa', 'Krasnoïarsk', 'Voronej', 'Volgograd', 'Sotchi'],
  MT: ['La Valette', 'Birkirkara', 'Mosta', 'Qormi', 'Sliema', 'Saint-Julien'],
  CY: ['Nicosie', 'Limassol', 'Larnaca', 'Famagouste', 'Paphos', 'Kyrenia'],
  AD: ['Andorre-la-Vieille', 'Escaldes-Engordany', 'Encamp', 'Sant Julià de Lòria', 'La Massana'],
  SM: ['Saint-Marin', 'Serravalle', 'Borgo Maggiore', 'Domagnano'],
  LI: ['Vaduz', 'Schaan', 'Triesen', 'Balzers', 'Eschen'],
  US: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphie', 'San Antonio', 'San Diego', 'Dallas', 'San José', 'Austin', 'Jacksonville', 'San Francisco', 'Seattle', 'Denver', 'Washington', 'Boston', 'Miami', 'Atlanta', 'Las Vegas', 'Nouvelle-Orléans', 'Detroit', 'Portland', 'Nashville', 'Orlando'],
  MX: ['Mexico', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'León', 'Ciudad Juárez', 'Cancún', 'Mérida', 'Querétaro', 'Acapulco'],
  BR: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Manaus', 'Curitiba', 'Recife', 'Porto Alegre', 'Belém', 'Goiânia'],
  AR: ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe'],
  CL: ['Santiago', 'Valparaíso', 'Concepción', 'La Serena', 'Antofagasta', 'Temuco', 'Viña del Mar'],
  CO: ['Bogota', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Cúcuta', 'Bucaramanga', 'Pereira'],
  PE: ['Lima', 'Arequipa', 'Trujillo', 'Chiclayo', 'Piura', 'Cusco', 'Iquitos'],
  VE: ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto', 'Maracay', 'Ciudad Guayana'],
  EC: ['Quito', 'Guayaquil', 'Cuenca', 'Santo Domingo', 'Ambato', 'Manta'],
  BO: ['La Paz', 'Santa Cruz', 'Cochabamba', 'Sucre', 'Oruro', 'Tarija'],
  PY: ['Asunción', 'Ciudad del Este', 'San Lorenzo', 'Luque', 'Capiatá'],
  UY: ['Montevideo', 'Salto', 'Paysandú', 'Las Piedras', 'Maldonado', 'Punta del Este'],
  GT: ['Guatemala', 'Mixco', 'Villa Nueva', 'Quetzaltenango', 'Escuintla'],
  CU: ['La Havane', 'Santiago de Cuba', 'Camagüey', 'Holguín', 'Santa Clara', 'Varadero'],
  DO: ['Saint-Domingue', 'Santiago', 'La Romana', 'Punta Cana', 'Puerto Plata', 'San Pedro de Macorís'],
  HT: ['Port-au-Prince', 'Cap-Haïtien', 'Carrefour', 'Delmas', 'Pétion-Ville', 'Les Cayes'],
  CR: ['San José', 'Alajuela', 'Cartago', 'Heredia', 'Liberia', 'Puntarenas'],
  PA: ['Panama', 'San Miguelito', 'Colón', 'David', 'La Chorrera'],
  HN: ['Tegucigalpa', 'San Pedro Sula', 'Choloma', 'La Ceiba', 'Comayagua'],
  NI: ['Managua', 'León', 'Masaya', 'Granada', 'Chinandega'],
  SV: ['San Salvador', 'Santa Ana', 'San Miguel', 'Soyapango', 'Mejicanos'],
  JM: ['Kingston', 'Montego Bay', 'Spanish Town', 'Portmore', 'May Pen'],
  TT: ["Port-d'Espagne", 'San Fernando', 'Chaguanas', 'Arima', 'Point Fortin'],
  MA: ['Casablanca', 'Rabat', 'Fès', 'Marrakech', 'Tanger', 'Meknès', 'Agadir', 'Oujda', 'Kénitra', 'Tétouan', 'Salé', 'Mohammédia', 'El Jadida', 'Nador', 'Essaouira', 'Ouarzazate'],
  DZ: ['Alger', 'Oran', 'Constantine', 'Annaba', 'Blida', 'Batna', 'Sétif', 'Sidi Bel Abbès', 'Biskra', 'Tlemcen', 'Béjaïa', 'Tizi Ouzou', 'Ghardaïa'],
  TN: ['Tunis', 'Sfax', 'Sousse', 'Kairouan', 'Bizerte', 'Gabès', 'Ariana', 'Gafsa', 'Monastir', 'Nabeul', 'Hammamet', 'Djerba'],
  LY: ['Tripoli', 'Benghazi', 'Misrata', 'Zaouïa', 'Zliten', 'Syrte', 'Sebha'],
  EG: ['Le Caire', 'Alexandrie', 'Gizeh', 'Charm el-Cheikh', 'Louxor', 'Assouan', 'Port-Saïd', 'Suez', 'Mansoura', 'Hurghada'],
  SN: ['Dakar', 'Thiès', 'Touba', 'Rufisque', 'Kaolack', 'Saint-Louis', 'Ziguinchor', 'Diourbel', 'Mbour', 'Louga', 'Tambacounda'],
  CI: ['Abidjan', 'Bouaké', 'Yamoussoukro', 'Daloa', 'Korhogo', 'San-Pédro', 'Gagnoa', 'Man', 'Divo', 'Anyama', 'Abengourou'],
  CM: ['Douala', 'Yaoundé', 'Garoua', 'Bamenda', 'Maroua', 'Bafoussam', 'Ngaoundéré', 'Bertoua', 'Ebolowa', 'Kribi', 'Limbé', 'Buéa', 'Édéa', 'Kumba', 'Nkongsamba'],
  CD: ['Kinshasa', 'Lubumbashi', 'Mbuji-Mayi', 'Kananga', 'Kisangani', 'Bukavu', 'Goma', 'Likasi', 'Kolwezi', 'Matadi', 'Tshikapa', 'Boma'],
  CG: ['Brazzaville', 'Pointe-Noire', 'Dolisie', 'Nkayi', 'Ouesso', 'Owando'],
  GA: ['Libreville', 'Port-Gentil', 'Franceville', 'Oyem', 'Moanda', 'Lambaréné'],
  BJ: ['Cotonou', 'Porto-Novo', 'Parakou', 'Djougou', 'Bohicon', 'Abomey', 'Natitingou', 'Ouidah'],
  TG: ['Lomé', 'Sokodé', 'Kara', 'Kpalimé', 'Atakpamé', 'Dapaong', 'Tsévié'],
  ML: ['Bamako', 'Sikasso', 'Ségou', 'Mopti', 'Koutiala', 'Kayes', 'Gao', 'Tombouctou'],
  BF: ['Ouagadougou', 'Bobo-Dioulasso', 'Koudougou', 'Ouahigouya', 'Banfora', 'Kaya'],
  NE: ['Niamey', 'Zinder', 'Maradi', 'Agadez', 'Tahoua', 'Dosso'],
  GN: ['Conakry', 'Nzérékoré', 'Kankan', 'Kindia', 'Labé', 'Boké'],
  GW: ['Bissau', 'Bafatá', 'Gabú', 'Bissorã', 'Bolama'],
  GQ: ['Malabo', 'Bata', 'Ebebiyín', 'Aconibe', 'Añisoc'],
  MR: ['Nouakchott', 'Nouadhibou', 'Rosso', 'Kaédi', 'Kiffa', 'Zouérat'],
  TD: ["N'Djamena", 'Moundou', 'Sarh', 'Abéché', 'Kelo', 'Koumra'],
  CF: ['Bangui', 'Bimbo', 'Berbérati', 'Carnot', 'Bambari', 'Bouar'],
  RW: ['Kigali', 'Butare', 'Gitarama', 'Ruhengeri', 'Gisenyi', 'Cyangugu'],
  BI: ['Bujumbura', 'Gitega', 'Ngozi', 'Rumonge', 'Bururi', 'Muyinga'],
  DJ: ['Djibouti', 'Ali Sabieh', 'Tadjourah', 'Obock', 'Dikhil'],
  MG: ['Antananarivo', 'Toamasina', 'Antsirabe', 'Mahajanga', 'Fianarantsoa', 'Toliara', 'Antsiranana', 'Nosy Be'],
  MU: ['Port-Louis', 'Beau-Bassin Rose-Hill', 'Vacoas-Phoenix', 'Curepipe', 'Quatre Bornes', 'Grand Baie'],
  SC: ['Victoria', 'Anse Boileau', 'Beau Vallon', 'Takamaka'],
  KM: ['Moroni', 'Mutsamudu', 'Fomboni', 'Domoni'],
  ST: ['São Tomé', 'Santo António', 'Neves', 'Trindade'],
  CV: ['Praia', 'Mindelo', 'Santa Maria', 'Assomada', 'Espargos'],
  NG: ['Lagos', 'Kano', 'Ibadan', 'Abuja', 'Port Harcourt', 'Benin City', 'Kaduna', 'Enugu', 'Aba', 'Onitsha'],
  GH: ['Accra', 'Kumasi', 'Tamale', 'Takoradi', 'Cape Coast', 'Tema', 'Koforidua'],
  KE: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Malindi'],
  TZ: ['Dar es Salaam', 'Dodoma', 'Mwanza', 'Arusha', 'Zanzibar', 'Mbeya'],
  UG: ['Kampala', 'Gulu', 'Lira', 'Mbarara', 'Jinja', 'Entebbe'],
  ET: ['Addis-Abeba', 'Dire Dawa', 'Mekele', 'Gondar', 'Bahir Dar', 'Awasa'],
  ZA: ['Johannesburg', 'Le Cap', 'Durban', 'Pretoria', 'Port Elizabeth', 'Bloemfontein', 'East London', 'Soweto'],
  AO: ['Luanda', 'Huambo', 'Lobito', 'Benguela', 'Lubango', 'Cabinda'],
  MZ: ['Maputo', 'Matola', 'Beira', 'Nampula', 'Chimoio', 'Nacala'],
  ZM: ['Lusaka', 'Kitwe', 'Ndola', 'Kabwe', 'Chingola', 'Livingstone'],
  ZW: ['Harare', 'Bulawayo', 'Chitungwiza', 'Mutare', 'Gweru', 'Victoria Falls'],
  BW: ['Gaborone', 'Francistown', 'Molepolole', 'Maun', 'Serowe'],
  NA: ['Windhoek', 'Walvis Bay', 'Swakopmund', 'Rundu', 'Oshakati'],
  SD: ['Khartoum', 'Omdurman', 'Port-Soudan', 'Kassala', 'Nyala', 'El Obeid'],
  GM: ['Banjul', 'Serekunda', 'Brikama', 'Bakau', 'Farafenni'],
  SL: ['Freetown', 'Bo', 'Kenema', 'Makeni', 'Koidu'],
  LR: ['Monrovia', 'Gbarnga', 'Buchanan', 'Kakata', 'Voinjama'],
  MW: ['Lilongwe', 'Blantyre', 'Mzuzu', 'Zomba', 'Kasungu'],
  SA: ['Riyad', 'Djeddah', 'La Mecque', 'Médine', 'Dammam', 'Taïf', 'Tabuk', 'Khobar'],
  AE: ['Dubaï', 'Abou Dhabi', 'Charjah', 'Al-Aïn', 'Ajman', 'Ras el Khaïmah', 'Foujaïrah'],
  QA: ['Doha', 'Al Rayyan', 'Al Wakrah', 'Al Khor', 'Lusail'],
  KW: ['Koweït', 'Al Ahmadi', 'Hawalli', 'Salmiya', 'Jahra'],
  BH: ['Manama', 'Riffa', 'Muharraq', 'Hamad Town', 'Isa Town'],
  OM: ['Mascate', 'Salalah', 'Sohar', 'Nizwa', 'Sur'],
  JO: ['Amman', 'Zarka', 'Irbid', 'Aqaba', 'Madaba', 'Petra'],
  LB: ['Beyrouth', 'Tripoli', 'Saïda', 'Tyr', 'Jounieh', 'Byblos', 'Zahlé'],
  IL: ['Jérusalem', 'Tel-Aviv', 'Haïfa', 'Rishon LeZion', 'Petah Tikva', 'Netanya', 'Eilat'],
  PS: ['Gaza', 'Hébron', 'Naplouse', 'Ramallah', 'Bethléem', 'Jénine'],
  TR: ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Antalya', 'Adana', 'Konya', 'Gaziantep', 'Kayseri', 'Bodrum'],
  IR: ['Téhéran', 'Machhad', 'Ispahan', 'Karaj', 'Chiraz', 'Tabriz', 'Qom'],
  IQ: ['Bagdad', 'Bassorah', 'Mossoul', 'Erbil', 'Nadjaf', 'Kirkouk'],
  SY: ['Damas', 'Alep', 'Homs', 'Lattaquié', 'Hama', 'Deir ez-Zor'],
  YE: ['Sanaa', 'Aden', 'Taïz', 'Hodeïda', 'Moukalla'],
  CN: ['Pékin', 'Shanghai', 'Canton', 'Shenzhen', 'Chengdu', 'Wuhan', 'Xian', 'Hangzhou', 'Nankin', 'Chongqing', 'Tianjin', 'Suzhou'],
  JP: ['Tokyo', 'Yokohama', 'Osaka', 'Nagoya', 'Sapporo', 'Kobe', 'Kyoto', 'Fukuoka', 'Kawasaki', 'Hiroshima'],
  KR: ['Séoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju', 'Suwon', 'Ulsan'],
  IN: ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Ahmedabad', 'Chennai', 'Calcutta', 'Pune', 'Jaipur', 'Lucknow', 'Goa'],
  PK: ['Karachi', 'Lahore', 'Faisalabad', 'Rawalpindi', 'Islamabad', 'Multan', 'Peshawar'],
  BD: ['Dacca', 'Chittagong', 'Khulna', 'Rajshahi', 'Sylhet', 'Comilla'],
  LK: ['Colombo', 'Kandy', 'Galle', 'Jaffna', 'Negombo', 'Trincomalee'],
  NP: ['Katmandou', 'Pokhara', 'Lalitpur', 'Biratnagar', 'Bharatpur'],
  TH: ['Bangkok', 'Nonthaburi', 'Chiang Mai', 'Pattaya', 'Phuket', 'Hat Yai', 'Krabi'],
  VN: ['Hô Chi Minh-Ville', 'Hanoï', 'Da Nang', 'Hai Phong', 'Can Tho', 'Nha Trang', 'Hué'],
  ID: ['Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Semarang', 'Makassar', 'Denpasar', 'Bali'],
  MY: ['Kuala Lumpur', 'George Town', 'Ipoh', 'Johor Bahru', 'Malacca', 'Kota Kinabalu', 'Kuching'],
  SG: ['Singapour'],
  PH: ['Manille', 'Quezon City', 'Davao', 'Cebu', 'Makati', 'Baguio'],
  KH: ['Phnom Penh', 'Siem Reap', 'Battambang', 'Sihanoukville', 'Kampot'],
  LA: ['Vientiane', 'Luang Prabang', 'Savannakhet', 'Paksé'],
  MM: ['Rangoun', 'Mandalay', 'Naypyidaw', 'Bago', 'Bagan'],
  KZ: ['Almaty', 'Astana', 'Chymkent', 'Karaganda', 'Aktobe'],
  UZ: ['Tachkent', 'Samarcande', 'Namangan', 'Boukhara', 'Andijan'],
  AZ: ['Bakou', 'Gandja', 'Soumgaït', 'Mingachevir', 'Lankaran'],
  GE: ['Tbilissi', 'Koutaïssi', 'Batoumi', 'Roustavi', 'Gori'],
  AM: ['Erevan', 'Gyumri', 'Vanadzor', 'Vagharchapat', 'Hrazdan'],
  AU: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adélaïde', 'Gold Coast', 'Canberra', 'Newcastle', 'Cairns'],
  NZ: ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga', 'Dunedin', 'Queenstown'],
  FJ: ['Suva', 'Nadi', 'Lautoka', 'Labasa'],
  PF: ['Papeete', 'Faaa', 'Punaauia', 'Bora-Bora', 'Moorea'],
  NC: ['Nouméa', 'Mont-Dore', 'Dumbéa', 'Païta'],
  RE: ['Saint-Denis', 'Saint-Paul', 'Saint-Pierre', 'Le Tampon', 'Saint-André', 'Saint-Louis'],
  GP: ['Pointe-à-Pitre', 'Les Abymes', 'Baie-Mahault', 'Le Gosier', 'Basse-Terre', 'Sainte-Anne'],
  MQ: ['Fort-de-France', 'Le Lamentin', 'Le Robert', 'Schoelcher', 'Sainte-Marie', 'Les Trois-Îlets'],
  GF: ['Cayenne', 'Saint-Laurent-du-Maroni', 'Kourou', 'Matoury', 'Rémire-Montjoly'],
  YT: ['Mamoudzou', 'Koungou', 'Dzaoudzi', 'Dembéni', 'Sada'],
  AF: ['Kaboul', 'Kandahar', 'Hérat', 'Mazâr-e Charîf', 'Jalalabad', 'Kunduz'],
  BS: ['Nassau', 'Freeport', 'West End', 'Coopers Town'],
  BB: ['Bridgetown', 'Speightstown', 'Oistins', 'Holetown'],
  BZ: ['Belize City', 'Belmopan', 'San Ignacio', 'Orange Walk', 'Dangriga'],
  BT: ['Thimphou', 'Phuntsholing', 'Paro', 'Punakha', 'Wangdue'],
  BN: ['Bandar Seri Begawan', 'Kuala Belait', 'Seria', 'Tutong'],
  DM: ['Roseau', 'Portsmouth', 'Marigot', 'Berekua'],
  AG: ['Saint John\'s', 'All Saints', 'Liberta', 'Codrington'],
  ER: ['Asmara', 'Keren', 'Massaoua', 'Assab', 'Mendefera'],
  SZ: ['Mbabane', 'Manzini', 'Lobamba', 'Siteki'],
  GD: ['Saint-Georges', 'Gouyave', 'Grenville', 'Victoria'],
  GY: ['Georgetown', 'Linden', 'New Amsterdam', 'Bartica'],
  KI: ['Tarawa-Sud', 'Betio', 'Bikenibeu'],
  KG: ['Bichkek', 'Och', 'Djalal-Abad', 'Karakol', 'Tokmok'],
  LS: ['Maseru', 'Teyateyaneng', 'Mafeteng', 'Hlotse', 'Mohale\'s Hoek'],
  MV: ['Malé', 'Addu', 'Fuvahmulah', 'Kulhudhuffushi'],
  MH: ['Majuro', 'Ebeye', 'Arno'],
  FM: ['Palikir', 'Weno', 'Kolonia', 'Colonia'],
  MN: ['Oulan-Bator', 'Erdenet', 'Darkhan', 'Choibalsan'],
  NR: ['Yaren', 'Denigomodu', 'Meneng'],
  PW: ['Ngerulmud', 'Koror', 'Airai'],
  PG: ['Port Moresby', 'Lae', 'Mount Hagen', 'Madang', 'Rabaul'],
  KN: ['Basseterre', 'Charlestown', 'Cayon'],
  LC: ['Castries', 'Vieux Fort', 'Gros Islet', 'Soufrière'],
  VC: ['Kingstown', 'Georgetown', 'Byera', 'Chateaubelair'],
  WS: ['Apia', 'Vaitele', 'Faleula', 'Siusega'],
  SB: ['Honiara', 'Auki', 'Gizo', 'Munda'],
  SO: ['Mogadiscio', 'Hargeisa', 'Kismaayo', 'Berbera', 'Boossaaso'],
  SS: ['Djouba', 'Wau', 'Malakal', 'Yei', 'Yambio'],
  SR: ['Paramaribo', 'Lelydorp', 'Nieuw Nickerie', 'Moengo'],
  TJ: ['Douchanbé', 'Khodjent', 'Kulob', 'Bokhtar', 'Istaravchan'],
  TL: ['Dili', 'Baucau', 'Maliana', 'Suai', 'Liquiçá'],
  TO: ['Nuku\'alofa', 'Neiafu', 'Haveluloto'],
  TM: ['Achgabat', 'Türkmenabat', 'Daşoguz', 'Mary', 'Balkanabat'],
  TV: ['Funafuti', 'Asau', 'Tanrake'],
  VU: ['Port-Vila', 'Luganville', 'Isangel', 'Lakatoro'],
  VA: ['Cité du Vatican'],
  TW: ['Taipei', 'Kaohsiung', 'Taichung', 'Tainan', 'Taoyuan', 'Hsinchu'],
  MF: ['Marigot', 'Grand-Case', 'Quartier d\'Orléans'],
  BL: ['Gustavia', 'Saint-Jean', 'Lorient'],
  PM: ['Saint-Pierre', 'Miquelon'],
  WF: ['Mata-Utu', 'Leava', 'Alele'],
  GI: ['Gibraltar'],
  GL: ['Nuuk', 'Sisimiut', 'Ilulissat', 'Qaqortoq', 'Aasiaat'],
  FO: ['Tórshavn', 'Klaksvík', 'Runavík', 'Tvøroyri'],
  JE: ['Saint-Hélier', 'Saint-Sauveur', 'Saint-Clément'],
  GG: ['Saint-Pierre-Port', 'Saint-Sampson', 'Vale'],
  IM: ['Douglas', 'Ramsey', 'Peel', 'Castletown'],
  HK: ['Hong Kong', 'Kowloon', 'Tsuen Wan', 'Sha Tin'],
  MO: ['Macao', 'Taipa', 'Coloane'],
  PR: ['San Juan', 'Bayamón', 'Carolina', 'Ponce', 'Caguas', 'Mayagüez'],
  AW: ['Oranjestad', 'San Nicolas', 'Noord', 'Santa Cruz'],
  CW: ['Willemstad', 'Barber', 'Sint Michiel'],
}

// Returns the country entry for a given code (or null).
export const getCountryByCode = (code) =>
  COUNTRIES.find((c) => c.code === code) || null

// Returns the list of known cities for a country code (may be empty).
export const getCitiesForCountry = (code) => CITIES_BY_COUNTRY[code] || []

// Localised country-name resolution using the built-in Intl.DisplayNames API.
// Falls back to the stored French name when the locale/code is unsupported.
const _displayNamesCache = {}
const _getDisplayNames = (lang) => {
  const key = lang || 'fr'
  if (!(key in _displayNamesCache)) {
    try {
      _displayNamesCache[key] = new Intl.DisplayNames([key], { type: 'region' })
    } catch {
      _displayNamesCache[key] = null
    }
  }
  return _displayNamesCache[key]
}

// Returns the country name translated into the given language (e.g. 'fr', 'en',
// 'de', 'nl'). Uses the ISO code; falls back to the stored French name.
export const getCountryName = (code, lang = 'fr') => {
  const entry = getCountryByCode(code)
  const fallback = entry ? entry.name : (code || '')
  if (!code) return fallback
  const dn = _getDisplayNames((lang || 'fr').slice(0, 2))
  if (dn) {
    try {
      const localized = dn.of(code)
      if (localized && localized !== code) return localized
    } catch {
      // invalid region code — use fallback
    }
  }
  return fallback
}
